import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=4b2644e4&scoped=true&"
import script from "./MediaImage.vue?vue&type=script&lang=js&"
export * from "./MediaImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2644e4",
  null
  
)

export default component.exports